import React from 'react';
import CircleList from './CircleList';

export const ShopperDeleteButLeadsCircle = ({
  messageReCircles,
  circlesLead,
}) => {

  return (
    <>
      <br/>
      <p>
        {messageReCircles}
      </p>
      <CircleList
        circles = {circlesLead}
        leaderBased = {true}
      />
    </>
  )
}

export default ShopperDeleteButLeadsCircle;